import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { CondicionPagoSelect } from 'sharedComponents/select'

const CondicionPagoFormGroup = ({ iError, iTouched, fIsSubmitting, flagNota, flagEditarComentarios }) => {
  return (
    <Form.Group>
      <Form.Label text='C. DE PAGO' htmlFor='select-CondicionDePago' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='condicionPago'>
          {({ field }) => (
            <CondicionPagoSelect
              {...field}
              disabled={fIsSubmitting || flagNota || flagEditarComentarios}
              isInvalid={iTouched && iError}
              id='select-CondicionDePago'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CondicionPagoFormGroup)
